import { Typography } from '@mui/material';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import { useApproveStatusOfApartment } from '../../assets/api/useApartmentApi';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';

const TermAndConditionTable = ({ id }) => {
    const { data: termAndCondition, isLoading } = useApproveStatusOfApartment({ apartment_id: id })
    const termConditionRow = termAndCondition?.apartment_terms?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) || []
    const termAndConditionColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },

        {
            field: "date_of_approval",
            headerName: "Date of Action",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },
        {
            field: "security_deposit",
            headerName: "Security Deposit",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "terms_conditions",
            headerName: "Term And Condition",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "accepted_by_user",
            headerName: "Action By",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value == 2 ? "Accepted" : "Rejected"}</Typography>,
        },
    ]
    return (
        <>


            <TableFilterTemplate
                title="Term And Condition"
                columns={termAndConditionColumns}
                rowsData={termConditionRow || []}
                isLoading={isLoading}


            />

        </>
    )
}

export default TermAndConditionTable